import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-basic-popup-modal',
  templateUrl: './basic-popup-modal.component.html',
  styleUrls: ['./basic-popup-modal.component.scss']
})

/**
 * Basic Popup Component meant to serve as a generic pop up screen
 * 
 * Simply set the title and msg body
 * 
 */
export class BasicPopupModalComponent {
  title: string;
  message: string;
  constructor(private activeModalService: NgbActiveModal) { }


  close(){
    this.activeModalService.dismiss();
  }
}
